import TradeRequestChatWithAdmin from '../pages/TradeRequestChatWithAdmin.vue';

const tradeRequestChatWithAdminRoutes = [
  {
    path: '/trade-request-chat-with-admin/:id',
    name: 'درخواست مناقصه/ارسال پیام به ادمین',
    component: TradeRequestChatWithAdmin,
  },
 
];

export default tradeRequestChatWithAdminRoutes;